/**
* Deep copy the given object.
*/
export function deepCopy(obj){
    if (obj === null || typeof obj !== 'object') {
        return obj
    }

    const copy = Array.isArray(obj) ? [] : {}

    Object.keys(obj).forEach((key) => {
        copy[key] = deepCopy(obj[key])
    })

    return copy
}

/**
* If the given value is not an array, wrap it in one.
*/
export function arrayWrap(value){
    return Array.isArray(value) ? value : [value]
}

/**
* Determine if the given data has files.
*/
export function hasFiles(data){
    return data instanceof File ||
        data instanceof Blob ||
        data instanceof FileList ||
        (typeof data === 'object' && data !== null && Object.values(data).find(value => hasFiles(value)) !==
            undefined)
}

/**
 * Replace Values
 */
export function convertIntakeValue(value){
    const values = {
        'less_than_100k': 'Less than $100,000',
        '100k_200k': '$100,000 - $200,000',
        '200k_300k': '$200,000 - $300,000',
        '300k_750k': '$300,000 - $750,000',
        '750k_plus': '$750,000 +',
        '100k_1m': '$100,000 - $1,000,000',
        '1m_2p2m': '$1,000,000 - $2,200,000',
        '2p2m_5m': '$2,200,000 - $5,000,000',
        '5m_plus': '$5,000,000 +',
        '100k_500k': '$100,000 - $500,000',
        '500k_1m': '$500,000 - $1,000,000',
        '1m_4m': '$1,000,000 - $4,000,000',
        '4m_plus': '$4,000,000 +',
        '15_or_less': '15% or less',
        '16_25': '16% - 25%',
        '26_35': '26% - 35%',
        '35_plus': '36%+',
        'less_10': 'Less than 10%',
        '11_15': '11% - 15%',
        '15_20': '15% - 20%',
        '20_67': '20% - 67%',
        '68_100': '68% - 100%',
        'individual': 'Individual',
        'entity': 'Entity',
        'joint-tenants-survivorship': 'Joint Tenants with Rights of Survivorship (most common)',
        'joint-tenants-common': 'Tenants in Common',
        'joint-tenants-entirety': 'Tenants by Entirety',
        'ira-traditional': 'Traditional IRA',
        'ira-roth': 'Roth IRA',
    }

    return _.get(values, value, value)
}
